import React from 'react';

const CtaTwo = () => {
  return null;
};

export default CtaTwo;
